// extracted by mini-css-extract-plugin
export var closeButton = "_1m-3";
export var header = "_1m-0";
export var link = "_1m-1";
export var retryButton = "_1m-2";